import type { SVGProps } from 'react';

type P = SVGProps<SVGSVGElement> & { size?: number };

function Svg({ size = 16, children, strokeWidth = 1.7, ...rest }: P) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {children}
    </svg>
  );
}

export const IconTheme = (p: P) => (
  <Svg {...p} strokeWidth={1.6}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 3.5a8.5 8.5 0 0 1 0 17z" fill="currentColor" />
  </Svg>
);
export const IconSearch = (p: P) => (
  <Svg {...p}>
    <circle cx="11" cy="11" r="6.5" />
    <path d="M16 16l4.5 4.5" />
  </Svg>
);
export const IconPlus = (p: P) => (
  <Svg {...p} strokeWidth={1.6}>
    <path d="M12 4v16M4 12h16" />
  </Svg>
);
export const IconClose = (p: P) => (
  <Svg {...p} strokeWidth={1.6}>
    <path d="M6 6l12 12M18 6L6 18" />
  </Svg>
);
export const IconCopy = (p: P) => (
  <Svg {...p}>
    <rect x="8.5" y="8.5" width="11" height="11" />
    <path d="M15.5 8.5V4.5h-11v11h4" />
  </Svg>
);
export const IconRefresh = (p: P) => (
  <Svg {...p}>
    <path d="M19.5 12a7.5 7.5 0 1 1-2.2-5.3" />
    <path d="M19.5 4.5v4h-4" />
  </Svg>
);
export const IconUpload = (p: P) => (
  <Svg {...p}>
    <path d="M12 16V4M7 9l5-5 5 5M4.5 19.5h15" />
  </Svg>
);
export const IconDownload = (p: P) => (
  <Svg {...p}>
    <path d="M12 4v12M7 11l5 5 5-5M4.5 19.5h15" />
  </Svg>
);
export const IconArrowRight = (p: P) => (
  <Svg {...p}>
    <path d="M4 12h16M14 6l6 6-6 6" />
  </Svg>
);
export const IconArrowLeft = (p: P) => (
  <Svg {...p}>
    <path d="M20 12H4M10 6l-6 6 6 6" />
  </Svg>
);
export const IconCheck = (p: P) => (
  <Svg {...p}>
    <path d="M5 12.5l4.5 4.5L19 7.5" />
  </Svg>
);
export const IconLogout = (p: P) => (
  <Svg {...p}>
    <path d="M14 4.5H5.5v15H14M10 12h10M16.5 8.5L20 12l-3.5 3.5" />
  </Svg>
);
export const IconMenu = (p: P) => (
  <Svg {...p} strokeWidth={1.6}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </Svg>
);
export const IconFile = (p: P) => (
  <Svg {...p}>
    <path d="M6 3.5h8l4 4v13H6z" />
    <path d="M14 3.5v4h4" />
  </Svg>
);
export const IconLink = (p: P) => (
  <Svg {...p}>
    <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1" />
    <path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" />
  </Svg>
);
export const IconTrash = (p: P) => (
  <Svg {...p}>
    <path d="M4.5 7h15M9.5 7V4.5h5V7M6.5 7l1 12.5h9l1-12.5" />
  </Svg>
);

/** Канали месенджерів — лише контурні піктограми, без брендових кольорів. */
export const IconTelegram = (p: P) => (
  <Svg {...p}>
    <path d="M20.5 4.5L3.5 11l5.5 2 2 6 3-4 4.5 3.5z" />
    <path d="M9 13l8-5.5" />
  </Svg>
);
export const IconViber = (p: P) => (
  <Svg {...p}>
    <path d="M12 3.5c-5 0-8 2-8 7.5 0 3 1 5 3 6v3.5l3-2.5h2c5 0 8-2 8-7s-3-7.5-8-7.5z" />
    <path d="M9.5 8.5c0 3 2.5 5.5 5.5 5.5l1-1.5-1.8-1-.9.8a3.5 3.5 0 0 1-2-2l.8-1-1-1.8z" />
  </Svg>
);
export const IconWhatsApp = (p: P) => (
  <Svg {...p}>
    <path d="M4 20l1.3-4.2A8.5 8.5 0 1 1 8.4 18.8z" />
    <path d="M9 8.5c0 3.5 3 6.5 6.5 6.5l1-1.5-2-1-1 .8a4 4 0 0 1-2.3-2.3l.8-1-1-2z" />
  </Svg>
);
export const IconChat = (p: P) => (
  <Svg {...p}>
    <path d="M4 5h16v11H9l-5 4z" />
    <path d="M8 9.5h8M8 12.5h5" />
  </Svg>
);
export const IconMail = (p: P) => (
  <Svg {...p}>
    <rect x="3.5" y="5.5" width="17" height="13" />
    <path d="M3.5 6.5l8.5 7 8.5-7" />
  </Svg>
);
export const IconPhone = (p: P) => (
  <Svg {...p}>
    <path d="M6.5 3.5h3l1.5 4-2 1.5a10 10 0 0 0 6 6l1.5-2 4 1.5v3c0 1-1 2-2 2C10.5 19.5 4.5 13.5 4.5 5.5c0-1 1-2 2-2z" />
  </Svg>
);

export function ChannelIcon({ channel, ...p }: P & { channel: string }) {
  switch (channel) {
    case 'telegram':
      return <IconTelegram {...p} />;
    case 'viber':
      return <IconViber {...p} />;
    case 'whatsapp':
      return <IconWhatsApp {...p} />;
    case 'email':
      return <IconMail {...p} />;
    case 'sms':
    case 'phone':
      return <IconPhone {...p} />;
    default:
      return <IconChat {...p} />;
  }
}
export const IconBug = (p: P) => (
  <Svg {...p}>
    <rect x="7" y="8" width="10" height="12" rx="5" />
    <path d="M9 8a3 3 0 0 1 6 0M12 12v8M7 13H3.5M20.5 13H17M7.5 17.5 4.5 20M16.5 17.5l3 2.5M7.5 9.5 5 7M16.5 9.5 19 7" />
  </Svg>
);
